import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { ApiApplicationSearchConstants } from "./api-application-search.constants";
let ApplicationSearchService = class ApplicationSearchService {
    sessionStorageService;
    http;
    router;
    constructor(sessionStorageService, http, router) {
        this.sessionStorageService = sessionStorageService;
        this.http = http;
        this.router = router;
    }
    getApplicationSearches(moduleId) {
        const params = {
            moduleId
        };
        return this.http.get(`${ApiApplicationSearchConstants.URL}/${ApiApplicationSearchConstants.FUNCTION_GET_SEARCHES}`, { params });
    }
    doApplicationSearch(params) {
        return this.http.post(`${ApiApplicationSearchConstants.URL}/${ApiApplicationSearchConstants.FUNCTION_SEARCH}`, params);
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: HttpClient },
        { type: Router }
    ];
};
ApplicationSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationSearchService);
export { ApplicationSearchService };
